<div class="box_default box_white custom_form view_form">
    <div class="loader" *ngIf="loadingFields$ | async; else dataContent">
        <div class="dimmed_outset">
            <div class="dimmed_line">
            </div>
        </div>
        <div class="dimmed">
            <div class="dimmed_title"></div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
            </div>
            <div class="dimmed_title"></div>
            <div class="dimmed_flex">
                <div class="dimmed_box"></div>
            </div>
        </div>
    </div>
    <!--   -->
    <ng-template #dataContent>
        <div class="box_main" *ngIf="(fields$ | async)?.length > 0 && dynamicLinKButtoncontext; else handleEmptyFieldsOrError">
                <div class="form-specifications form-fill">
                    <div class="form-fields">
                        <ul class="fields-list">
                            <!-- place in the li the new component for form  dynamic fields where each field will be loaded in html -->
                            <li class="fields-list-item"
                                *ngFor="let fieldSubmission of (fields$ | async | sortBy : 'fieldSubmission.field.position' : 'asc') ">
                                <custom-forms-dynamic-view-field-host
                                    [fieldSubmission]="fieldSubmission"
                                    [dynamicLinKButtoncontext] = "fieldSubmission.field.type === DYNAMIC_LINK_FIELD_TYPE ? dynamicLinKButtoncontext : null"
                                ></custom-forms-dynamic-view-field-host>
                            </li>
                        </ul>
                    </div>
                </div>
        </div>
        <!-- Template for handling both no data and errors -->
        <ng-template #handleEmptyFieldsOrError>
            <div class="custom-forms-errors" *ngIf="errorFields$ | async as error; else noFieldsData">
                <div [ngSwitch]="error.status">
                    <!-- TO REVIEW ng17 when ngSwitch check values directly due to strict comparison -->
                    <!-- Error handling for each status -->
                    <div *ngSwitchCase="404" class="error">
                        <core-helpers-box-http-error 
                            [code]="404"
                            [message]="'Not found. Check your URL.'"></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchCase="403" class="error">
                        <core-helpers-box-http-error 
                            [code]="403"
                            [message]="'Not allowed.'"></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchCase="500" class="error">
                        <core-helpers-box-http-error 
                            [code]="500"
                            [message]="'Internal server error, please refresh your browser. If the error persists, please reach out to our support team through the Help Me button.'"></core-helpers-box-http-error>
                    </div>
                    <div *ngSwitchDefault class="error">
                        <core-helpers-box-http-error 
                        [code]="''"
                            [message]="'Internal server error, please refresh your browser. If the error persists, please reach out to our support team through the Help Me button.'"></core-helpers-box-http-error>
                    </div>
                </div>
            </div>

            <ng-template #noFieldsData>
                <article class="forms-not-content">
                    <core-helpers-box-alert-message-icon [text]="'This form has no fields.'"
                        [icon]="'no_messages'"></core-helpers-box-alert-message-icon>
                </article>
            </ng-template>
        </ng-template>
    </ng-template>
</div>